import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { getChipClasses, getQuickPrompts } from '../../utils/ai/chatTheme';

const QUICK_PROMPT_PAGE_BY_PATH = {
  '/dashboard': 'qmetry360',
  '/gitDashboard': 'engMetricsGit',
  '/integration': 'integration',
  '/jiraDashboard': 'engMetricsJira',
  '/release': 'release',
  '/standUp': 'standup',
  '/techQuality': 'techQuality',
};

const resolveQuickPromptPage = (pathname = '') => {
  const normalizedPath = pathname.replace(/\/$/, '') || '/standUp';
  return QUICK_PROMPT_PAGE_BY_PATH[normalizedPath] || 'standup';
};

const ChatQuickPrompts = ({ theme = 'dark', disabled = false, onSelect }) => {
  const [pathname, setPathname] = useState(() =>
    typeof window !== 'undefined' ? window.location.pathname : '/standUp',
  );

  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const syncPathname = () => setPathname(window.location.pathname);
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    const notifyLocationChange = () => window.dispatchEvent(new Event('locationchange'));

    window.history.pushState = function pushState(...args) {
      const result = originalPushState.apply(this, args);
      notifyLocationChange();
      return result;
    };

    window.history.replaceState = function replaceState(...args) {
      const result = originalReplaceState.apply(this, args);
      notifyLocationChange();
      return result;
    };

    window.addEventListener('popstate', syncPathname);
    window.addEventListener('locationchange', syncPathname);
    syncPathname();

    return () => {
      window.removeEventListener('popstate', syncPathname);
      window.removeEventListener('locationchange', syncPathname);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  const page = resolveQuickPromptPage(pathname);
  const quickPrompts = getQuickPrompts(page);

  if (disabled) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 px-4 pb-2">
      {quickPrompts.map((prompt) => (
        <button
          key={prompt}
          type="button"
          onClick={() => onSelect?.(prompt)}
          className={`rounded-md px-2.5 py-1.5 text-xs font-medium transition ${getChipClasses(theme)}`}
        >
          {prompt}
        </button>
      ))}
    </div>
  );
};

ChatQuickPrompts.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']),
  disabled: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default ChatQuickPrompts;
